import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { Pagination } from 'components/Tables/Table.styles';

interface IChartWrapper {
  height?: number;
}

export const LoaderWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const NoData = styled.div`
  color: ${colors.grey7};
  font-size: 16px;
  letter-spacing: 0.3px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.div`
  color: ${colors.grey7};
  font-weight: 500;
  font-size: 23px;
  line-height: 31px;
  letter-spacing: 0.3px;
  margin-bottom: 32px;
  display: flex;
`;

export const Subtitle = styled.div`
  color: ${colors.grey5};
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  align-self: flex-end;
  padding: 0 0 3px 12px;
`;

export const TableWrapper = styled.div<IChartWrapper>`
  width: 100%;
  overflow: hidden;
  height: ${({ height }) => (height ? `${height}px` : 'auto')};

  .ag-theme-balham {
    width: 100%;
    height: 100%;
    font-family: 'Roboto';

    .ag-root,
    .ag-side-bar,
    .ag-root-wrapper,
    .ag-status-bar {
      border: none;
    }

    .ag-root-wrapper {
      border-bottom: 1px solid ${colors.grey3};
    }

    .ag-header-row {
      border-bottom: 0px;
    }

    .ag-header {
      background-color: transparent;
      border: none;
    }

    .ag-header-cell {
      text-transform: uppercase;
      font-weight: normal;
      font-size: 11px;
      letter-spacing: 0.8px;
      padding-bottom: 5px;

      &::after {
        display: none;
      }
    }

    .ag-row {
      background-color: transparent;
      border-color: ${colors.grey3};

      &.ag-row-last {
        border-bottom: none;
      }

      .ag-cell {
        font-size: 13px;
        font-weight: normal;
        line-height: 24px;
        letter-spacing: 0.3px;
        color: ${colors.grey7};
      }
    }

    .ag-floating-top-viewport {
      border: none;
    }

    .ag-floating-top {
      border-color: ${colors.grey3};
    }

    .ag-row-pinned {
      border: none;

      &.ag-row-last {
        border: none;
      }

      .ag-cell {
        font-weight: bold;
      }
    }

    .ag-header-row-column {
      border-bottom: 1px solid ${colors.grey3};
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ShowMoreWrapper = styled(Pagination)`
  margin-top: 20px;
`;
